import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { devices } from '../../devices'


export const BookingBtn = styled(Link).attrs({
    target: '_blank',
    rel: 'nofollow noopener',
})`
    display: flex;
    flex-direction: column;
    height: 40px;
    width: 148px;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid  ${({ theme }) => theme.colors.elementsGrey};
    text-align: center;
    text-decoration: none;
    overflow: hidden;
    &>span{
        display: flex;
        flex: 0 0 auto;
        width: 100%;
        height: 40px;
        justify-content: center;
        align-items: center;
        background:  ${({theme}) => theme.colors.accentColor};
        color:  ${({theme}) => theme.colors.background};
        transition: transform 0.3s ease-in-out;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
        text-transform: uppercase;
    }
    &>p{
        display: flex;
        flex: 0 0 auto;
        width: 100%;
        height: 40px;
        justify-content: center;
        align-items: center;
        background: ${({theme}) => theme.colors.white};
        color:  ${({theme}) => theme.colors.background};
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
        text-transform: uppercase;
        transition: transform 0.3s ease-in-out;
        &:before{
            padding-right: 8px;
            width: 17px;
            height: 17px;
            text-align: center;
            content: url("/svg/icons/shape.svg");
        }
    }
    &:hover{
        &>p,span{
            transform: translateY(-40px);
        }
        @media only screen and ${devices.md} {
            &>p,span{
                transform: unset;
            }
        }
    }
    
    
`